import PropTypes from "prop-types";
import React from "react";
import { MSpinner, ReadOnlyField } from "components/Shared";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Icon from "@mui/material/Icon";
import NotFoundPage from "components/NotFoundPage";
import { dateFormatterBefore1969 } from "components/Shared/Formatters";
import CaseRejections from "components/Homeowner/CaseForms/Actions/CaseRejections";

class CaseHeader extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      qaExpanded: true
    };
    this.renderAppraisalQaIssues = this.renderAppraisalQaIssues.bind(this);
    this.expanderClicked = this.expanderClicked.bind(this);
  }

  renderAppraisalQaIssues() {
    const { caseHeader } = this.props;
    let showAppraiserRejection = (caseHeader.caseInfo.hasAppraisalSurveyInfo && caseHeader.caseInfo.appraisalSurveyInfo?.appraiserRejectionCount > 0);
    if (!showAppraiserRejection) return "";

    return (
      <CaseRejections
        qaExpanded={this.state.qaExpanded}
        expanderClicked={this.expanderClicked}
        controlNumber={caseHeader.caseInfo.appraisalSurveyInfo?.id}
        unresolvedAppraiserRejectionCount={caseHeader.caseInfo.appraisalSurveyInfo?.unresolvedAppraiserRejectionCount}
        viewOnly={true}
      />
    );
  }

  expanderClicked(val) { this.setState({ qaExpanded: val }); }

  render() {
    const { isFetching, caseHeader } = this.props;
    if (isFetching) {
      return <MSpinner />;
    }
    if (!caseHeader.policyInfo) {
      return <NotFoundPage />;
    }

    let address = `${caseHeader.policyInfo.surveyAddress.address1} <br/> `;
    address += `${caseHeader.policyInfo.surveyAddress.city}, ${caseHeader.policyInfo.surveyAddress.state} ${caseHeader.policyInfo.surveyAddress.zip}`;
    let geocode = (caseHeader.policyInfo.geoCode && caseHeader.policyInfo.geoCode.latitude)
      ? `${caseHeader.policyInfo.geoCode.latitude}, ${caseHeader.policyInfo.geoCode.longitude}`
      : "Not provided";
    let customerName = `${caseHeader.policyInfo.customerInfo.customerName} (${caseHeader.policyInfo.customerInfo.customerNumber})`;
    let frNumber = caseHeader.caseInfo.inspectorNumber == null ? "Not Provided" : caseHeader.caseInfo.inspectorNumber;

    let transactionType = null;
    if (caseHeader.policyInfo.caseAttributes && caseHeader.policyInfo.caseAttributes.transactionType) {
      transactionType = caseHeader.policyInfo.caseAttributes.transactionType;
    }

    let webNotes = caseHeader.caseInfo.webNotes;
    if (webNotes != null && webNotes.length > 0) {
      webNotes = webNotes.replace(/(?:\r\n|\r|\n)/g, "<br />");
    } else {
      webNotes = "Not Provided";
    }

    let surveyRemarks = caseHeader.policyInfo.surveyRemarks;
    if (surveyRemarks != null && surveyRemarks.length > 0) {
      surveyRemarks = surveyRemarks.replace(/(?:\r\n|\r|\n)/g, "<br />");
    } else {
      surveyRemarks = "Not Provided";
    }

    // handle showing the appraiser rejection alert text
    let linkAddy = encodeURI(`https://maps.google.com/maps?q=${caseHeader.policyInfo.surveyAddress.address1},${caseHeader.policyInfo.surveyAddress.city},${caseHeader.policyInfo.surveyAddress.state},${caseHeader.policyInfo.surveyAddress.zip}`);

    /* eslint-disable react/no-danger */
    return (
      <div id={caseHeader.wrappableId} className="case-header md-grid">
        <Card className="md-cell md-cell--4">
          <CardContent>
            <Typography variant="h6">Contact Information</Typography>
          </CardContent>
          <CardContent>
            <ReadOnlyField title="Loan Number" fieldValue={caseHeader.policyInfo.policyHolderInfo.policyNumber} />
            <ReadOnlyField title="Borrower Name" fieldValue={caseHeader.policyInfo.policyHolderInfo.policyholderName.fullName} />
            <ReadOnlyField title="Field Rep. Number" fieldValue={frNumber} />
          </CardContent>
        </Card>
        <Card className="md-cell md-cell--4" >
          <CardContent>
            <Typography variant="h6">Subject Address</Typography>
          </CardContent>
          <CardContent className="survey_address">
            <ReadOnlyField title="Subject Property" fieldValue={address} rawHtml={true} link={linkAddy} />
            <ReadOnlyField title="County" fieldValue={caseHeader.policyInfo.surveyAddress.county} />
            <ReadOnlyField title="Geocode" fieldValue={geocode} />
            <ReadOnlyField title="Report Type" fieldValue={caseHeader.caseInfo.currentInspectionType.name} />
          </CardContent>
        </Card>
        <Card className="md-cell md-cell--right">
          <CardContent>
            <Typography variant="h6">Order Information</Typography>
          </CardContent>
          <CardContent>
            <div className="md-grid" style={{ padding: 0 }}>
              <ReadOnlyField containerClassName="md-cell--6" title="Mueller ID Number" fieldValue={caseHeader.caseInfo.controlNumber} />
              {transactionType && <ReadOnlyField containerClassName="md-cell--5" title="Assignment Type" fieldValue={transactionType} />}
            </div>
            <ReadOnlyField title="Lender/Client" fieldValue={customerName} />
            <ReadOnlyField title="Date Ordered" fieldValue={dateFormatterBefore1969(caseHeader.caseInfo.dateOrdered)} />
            <ReadOnlyField title="Date Inspected" fieldValue={dateFormatterBefore1969(caseHeader.caseInfo.dateSurveyed)} />
            <ReadOnlyField title="Date Completed" fieldValue={dateFormatterBefore1969(caseHeader.caseInfo.dateCompleted)} />
          </CardContent>
        </Card>
        <Card className="md-cell md-cell--6">
          <CardContent>
            <Typography variant="h6">Special Attention Notes</Typography>
          </CardContent>
          <CardContent>
            <div style={{ verticalAlign: "top", display: "inline-flex" }}>
              <Icon style={{ marginRight: "0.5em" }} title="Comments">comment</Icon>
              <div dangerouslySetInnerHTML={{ __html: webNotes }} />
            </div>
          </CardContent>
        </Card>
        <Card className="md-cell md-cell--6">
          <CardContent>
            <Typography variant="h6">Inspection Comments</Typography>
          </CardContent>
          <CardContent>
            <div style={{ verticalAlign: "top", display: "inline-flex" }}>
              <Icon style={{ marginRight: "0.5em" }} title="Comments">comment</Icon>
              <div dangerouslySetInnerHTML={{ __html: surveyRemarks }} />
            </div>
          </CardContent>
        </Card>
        {this.renderAppraisalQaIssues()}
      </div>
    );
    /* eslint-enable react/no-danger */
  }
}

CaseHeader.propTypes = {
  caseHeader: PropTypes.object.isRequired,
  isFetching: PropTypes.bool.isRequired,
};
export default CaseHeader;